export class FilterElementsModel {
    public browser = new Array<any>();
    public country = new Array<any>();
    public os = new Array<any>();
    public tokens = new Array<any>();

}



// WEBPACK FOOTER //
// ./src/app/core/models/filterElements.model.ts